/* eslint-disable */
// TEMPORARY visual mockup — lets the user compare alternative chat BUBBLE styles.
// Not wired to any backend. Renders faux data with the real .notes-scope theme.
// Route: /chat-bubble-preview?theme=light|dark
import React from 'react';
import { Check, CheckCheck } from 'lucide-react';

const useTheme = () => {
  const p = new URLSearchParams(window.location.search);
  return (p.get('theme') || 'light').toLowerCase();
};

// mine=true → right side.  read=true → seen (green), read=false → unread (red).
const MSGS = [
  { id: 1, mine: false, text: 'Hey! Did you get a chance to review the Q3 draft?', time: '3:58 PM', read: true },
  { id: 2, mine: true, text: 'Yes — looks great. Just a couple of tweaks on slide 4.', time: '3:59 PM', read: true },
  { id: 3, mine: false, text: 'Can we ship the update today?', time: '4:02 PM', read: true },
  { id: 4, mine: true, text: 'On it — deploying to staging now, will confirm in ~10 minutes once the checks pass.', time: '4:03 PM', read: false },
];

const hue = '#B8892E';
const Avatar = ({ size = 26, letter = 'A' }) => (
  <span className="grid shrink-0 place-items-center rounded-full font-bold text-white"
    style={{ width: size, height: size, background: hue, fontSize: size * 0.42 }}>{letter}</span>
);
const Tick = ({ read }) => (read
  ? <CheckCheck size={13} style={{ color: 'var(--n-success)' }} />
  : <Check size={13} style={{ color: 'var(--n-muted-2)' }} />);

const Meta = ({ m, tickColorOnly }) => (
  <span className="mt-0.5 flex items-center justify-end gap-1 text-[10px] tabular-nums" style={{ color: 'var(--n-muted)' }}>
    {m.time}{m.mine && <Tick read={m.read} />}
  </span>
);

// ── A · Bordered (current) ────────────────────────────────────────────────
const BubbleA = ({ m }) => {
  const border = m.read ? 'var(--n-success)' : 'var(--n-danger)';
  return (
    <div className={`flex ${m.mine ? 'justify-end' : 'justify-start'}`}>
      <div className="max-w-[80%] rounded-2xl border px-3 py-2 text-[13px] leading-relaxed"
        style={{ borderColor: border, background: m.mine ? 'var(--n-accent-bg)' : 'var(--n-surface-2)', color: 'var(--n-ink)',
          borderTopRightRadius: m.mine ? 5 : 16, borderTopLeftRadius: m.mine ? 16 : 5 }}>
        {m.text}<Meta m={m} />
      </div>
    </div>
  );
};

// ── B · Filled + status ring ──────────────────────────────────────────────
const BubbleB = ({ m }) => {
  const ring = m.read ? 'var(--n-success)' : 'var(--n-danger)';
  return (
    <div className={`flex ${m.mine ? 'justify-end' : 'justify-start'}`}>
      <div className="max-w-[80%] rounded-2xl px-3 py-2 text-[13px] leading-relaxed"
        style={{ background: m.mine ? 'var(--n-accent)' : 'var(--n-surface-2)', color: m.mine ? '#fff' : 'var(--n-ink)',
          boxShadow: `0 0 0 2px ${ring}`, borderTopRightRadius: m.mine ? 5 : 16, borderTopLeftRadius: m.mine ? 16 : 5 }}>
        {m.text}
        <span className="mt-0.5 flex items-center justify-end gap-1 text-[10px] tabular-nums" style={{ color: m.mine ? 'rgba(255,255,255,.8)' : 'var(--n-muted)' }}>
          {m.time}{m.mine && (m.read ? <CheckCheck size={13} /> : <Check size={13} style={{ opacity: .8 }} />)}
        </span>
      </div>
    </div>
  );
};

// ── C · Solid, ticks only (WhatsApp style) ────────────────────────────────
const BubbleC = ({ m }) => (
  <div className={`flex ${m.mine ? 'justify-end' : 'justify-start'}`}>
    <div className="max-w-[80%] px-3 py-2 text-[13px] leading-relaxed"
      style={{ background: m.mine ? 'var(--n-accent)' : 'var(--n-surface)', color: m.mine ? '#fff' : 'var(--n-ink)',
        borderRadius: 14, borderTopRightRadius: m.mine ? 4 : 14, borderTopLeftRadius: m.mine ? 14 : 4,
        boxShadow: '0 1px 1.5px rgba(0,0,0,.12)' }}>
      {m.text}
      <span className="mt-0.5 flex items-center justify-end gap-1 text-[10px] tabular-nums" style={{ color: m.mine ? 'rgba(255,255,255,.85)' : 'var(--n-muted)' }}>
        {m.time}{m.mine && (m.read ? <CheckCheck size={13} style={{ color: '#7fd1c4' }} /> : <Check size={13} style={{ opacity: .8 }} />)}
      </span>
    </div>
  </div>
);

// ── D · Left-stripe cards (status = stripe colour) ────────────────────────
const BubbleD = ({ m }) => {
  const stripe = m.read ? 'var(--n-success)' : 'var(--n-danger)';
  return (
    <div className={`flex ${m.mine ? 'justify-end' : 'justify-start'}`}>
      <div className="max-w-[82%] overflow-hidden text-[13px] leading-relaxed" style={{ borderRadius: 10, background: 'var(--n-surface-2)', color: 'var(--n-ink)', borderLeft: `3px solid ${stripe}` }}>
        <div className="px-3 py-2">{m.text}<Meta m={m} /></div>
      </div>
    </div>
  );
};

// ── E · Compact lines, no bubble (Slack style) ────────────────────────────
const BubbleE = ({ m }) => {
  const dot = m.read ? 'var(--n-success)' : 'var(--n-danger)';
  return (
    <div className="flex items-start gap-2 rounded-md px-1.5 py-1" style={{ background: m.read ? 'transparent' : 'var(--n-accent-bg)' }}>
      <Avatar size={26} letter={m.mine ? 'Y' : 'A'} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="text-[12px] font-semibold" style={{ color: m.mine ? 'var(--n-accent)' : 'var(--n-ink)' }}>{m.mine ? 'You' : 'Alice'}</span>
          <span className="text-[10px] tabular-nums" style={{ color: 'var(--n-muted-2)' }}>{m.time}</span>
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: dot }} />
        </div>
        <div className="text-[13px] leading-relaxed" style={{ color: 'var(--n-ink-soft)' }}>{m.text}</div>
      </div>
    </div>
  );
};

const VARIANTS = [
  { key: 'A', name: 'A · Bordered (current)', desc: 'Green border = read, red = unread. Tinted bubbles, tail corner.', Comp: BubbleA, gap: 'gap-2' },
  { key: 'B', name: 'B · Filled + status ring', desc: 'Solid bubbles with a thin green/red outline ring for read state.', Comp: BubbleB, gap: 'gap-2' },
  { key: 'C', name: 'C · Solid (ticks only)', desc: 'WhatsApp-style solid bubbles; read shown only by ✓✓ colour.', Comp: BubbleC, gap: 'gap-1.5' },
  { key: 'D', name: 'D · Left-stripe cards', desc: 'Flat cards with a coloured left stripe (green/red) for status.', Comp: BubbleD, gap: 'gap-2' },
  { key: 'E', name: 'E · Compact lines', desc: 'No bubbles (Slack-style). Read = small dot; unread row tinted.', Comp: BubbleE, gap: 'gap-1' },
];

const Phone = ({ v }) => (
  <div className="flex flex-col rounded-2xl border shadow-sm" style={{ borderColor: 'var(--n-border)', background: 'var(--n-canvas)', width: 340 }}>
    <div className="flex items-center gap-2 rounded-t-2xl border-b px-3 py-2.5" style={{ borderColor: 'var(--n-line)', background: 'var(--n-surface)' }}>
      <Avatar size={30} letter="A" />
      <span className="min-w-0">
        <span className="block text-[13px] font-semibold" style={{ color: 'var(--n-ink)' }}>Alice Kapoor</span>
        <span className="block text-[10.5px]" style={{ color: 'var(--n-success)' }}>online</span>
      </span>
    </div>
    <div className={`flex flex-col ${v.gap} px-3 py-3`} style={{ minHeight: 220 }}>
      {MSGS.map((m) => <v.Comp key={m.id} m={m} />)}
    </div>
  </div>
);

const Card = ({ v }) => (
  <div className="flex flex-col gap-2">
    <Phone v={v} />
    <div style={{ width: 340 }}>
      <div className="text-[13px] font-semibold" style={{ color: 'var(--n-ink)' }}>{v.name}</div>
      <div className="text-[11.5px] leading-snug" style={{ color: 'var(--n-muted)' }}>{v.desc}</div>
    </div>
  </div>
);

export default function ChatBubblePreview() {
  const theme = useTheme();
  return (
    <div className={`notes-scope ${theme === 'dark' ? 'dark' : ''}`} style={{ minHeight: '100vh', background: 'var(--n-canvas-2)' }}>
      <div className="mx-auto max-w-[1200px] px-6 py-8">
        <h1 className="font-display text-[24px] font-bold" style={{ color: 'var(--n-ink)' }}>Chat bubble styles</h1>
        <p className="mt-1 text-[13px]" style={{ color: 'var(--n-muted)' }}>
          Same conversation shown in five treatments. All use your existing Notes palette — only the bubble presentation changes.
          The last outgoing message is intentionally <b>unread</b> (red / single tick); the rest are <b>read</b> (green / double tick).
        </p>
        <div className="mt-7 flex flex-wrap gap-x-8 gap-y-9">
          {VARIANTS.map((v) => <Card key={v.key} v={v} />)}
        </div>
      </div>
    </div>
  );
}
